<template>
  <div :id="modalId" class="modal fade" tabindex="-1" aria-hidden="true" :aria-labelledby="`${modalId}-title`">
    <div class="modal-dialog modal-dialog-centered options-menu-dialog">
      <div class="modal-content options-menu">
        <div class="options-menu__header">
          <h5 :id="`${modalId}-title`" class="options-menu__title">{{ title }}</h5>
          <button type="button" class="btn-close options-menu__close" data-bs-dismiss="modal" :aria-label="$t('shared.close')"></button>
        </div>
        <div class="options-menu__group">
          <slot></slot>
        </div>
        <template v-if="hasPro">
          <div class="options-menu__pro-label">
            <span class="options-menu__pro-badge">{{ $t('shared.pro') }}</span>
          </div>
          <div class="options-menu__group">
            <slot name="pro"></slot>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script setup>
// The frame shared by the map Options dialogs (MapOptionsDialog and the planner's Options), so
// every map's menu reads the same: a compact list of OptionsMenuRow, with PRO+ tools grouped
// under their own label.
defineProps({
  modalId: { type: String, required: true },
  title: { type: String, required: true },
  hasPro: { type: Boolean, default: false },
});
</script>

<style scoped>
.options-menu-dialog {
  max-width: 360px;
}

.options-menu {
  padding: 10px 10px 14px;
  background: #1c1e22;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 16px;
  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.45);
}

.options-menu__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 8px 14px 12px;
}

.options-menu__title {
  margin: 0;
  font-size: 17px;
  font-weight: 700;
  color: #fff;
}

.options-menu__close {
  width: 10px;
  height: 10px;
  padding: 6px;
  background-size: 10px;
  opacity: 0.6;
}

.options-menu__close:hover {
  opacity: 1;
}

.options-menu__group {
  display: flex;
  flex-direction: column;
}

.options-menu__pro-label {
  padding: 18px 12px 10px;
}

.options-menu__pro-badge {
  display: inline-block;
  padding: 3px 8px;
  border-radius: 5px;
  background: #34c8ff;
  color: #000;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.02em;
}
</style>
